import React, { ComponentProps } from 'react'
import { useTranslation } from 'hooks/useTranslation'
import { HeroRoot, ImageColumn, CopyColumn, Header, Subheader, HeroBox, ImageWrapper } from './Hero.styles'
import Image from 'next/image'
import heroImage from '../../../../../../../public/assets/product-v2/all-products-hero.webp'

type HeroOwnProps = ComponentProps<typeof HeroRoot>
export type HeroProps = HeroOwnProps & {}

export const Hero = (_props: HeroProps) => {
  const { t } = useTranslation()

  return (
    <HeroRoot role='banner'>
      <HeroBox>
        <ImageColumn>
          <ImageWrapper>
            <Image
              objectFit="cover"
              layout="fill"
              src={heroImage}
              alt={t('products-v2:hero.image')}
            />
          </ImageWrapper>
        </ImageColumn>
        <CopyColumn>
          <Header>{t('products-v2:hero.title')}</Header>
          <Subheader>{t('products-v2:hero.subtitle')}</Subheader>
        </CopyColumn>
      </HeroBox>
    </HeroRoot>
  )
}

Hero.displayName = 'Hero'
